export default {
  settingOrderMoney: {
    amountType: 'Amount Type',
    unlimited: 'Unlimited',

    table: {
      priority: 'Priority Level',
      amountType: 'Amount Type',
      amount: 'Amount',
      logistics: 'Specified Logistics',
      business: 'Specified Business',
      updater: 'Updated By',
      lastUpdated: 'Last Updated Time',
    },

    dialog: {
      addTitle: 'Create order amount configuration',
      editTitle: 'Edit order amount configuration',
      amountRange: 'Amount Range',
      amountValid: 'Please enter the amount range',
      logistics: 'Specified Logistics',
      business: 'Specified Business',
      priority: 'Priority Level',
      priorityValid: 'Please enter priority level',
      selectAmountType: 'Please select the amount type',
      selectLogistics: 'Please select the specified logistics',
      selectBusiness: 'Please select the specified business',
      selectLogisticsValid: 'Please select the logistics provider first',
    }

  }
};
